import { CommonModule } from '@angular/common';
import { Component, Input } from '@angular/core';
import { RequestService } from 'app/shared/services/request.service';

@Component({
  selector: 'app-s3-image',
  standalone: true,
  imports: [CommonModule],
  templateUrl: './s3-image.component.html'
})
export class S3ImageComponent {
  @Input() path!: string;
  @Input() id!:any;

  imageUrl: string | null = null;
  fallbackUrl = '/assets/images/placeholder.png'; // Cambia con la tua immagine fallback
  showFallback = false;

  constructor(private requestService: RequestService) { }

  ngOnChanges() {
    if (this.id) {
      // const encodedPath = encodeURIComponent(this.path);
      this.requestService.getRequest(`files/${this.id}`)
        .subscribe({
          next: (res) => {
            this.imageUrl = res.url;
          },
          error: (err) => {
            console.error('Errore nel recupero dell’immagine:', err);
            this.showFallback = true;
          }
        });
    } else {
      this.showFallback = true;
    }
  }

  handleImageError() {
    this.showFallback = true;
  }
}
